import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';

import { ContainerCardContentTheme, ContainerCardPresentation } from '@ppg/core/enums';
import { ContainerCardContent } from '@ppg/core/models';
import { UrlCtaService } from '@ppg/shared/utils';

import { GeneralPresentationComponent } from './presentations/general-presentation/general-presentation.component';
import { InformationPresentationComponent } from './presentations/information-presentation/information-presentation.component';
import { LargeInformationPresentationComponent } from './presentations/large-information-presentation/large-information-presentation.component';
import { ListPresentationComponent } from './presentations/list-presentation/list-presentation.component';
import { MediaPresentationComponent } from './presentations/media-presentation/media-presentation.component';
import { TitlePresentationComponent } from './presentations/title-presentation/title-presentation.component';

@Component({
  selector: 'ppg-container-card-component',
  standalone: true,
  templateUrl: './container-card.component.html',
  styleUrl: './container-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    GeneralPresentationComponent,
    ListPresentationComponent,
    InformationPresentationComponent,
    LargeInformationPresentationComponent,
    TitlePresentationComponent,
    MediaPresentationComponent,
    ButtonModule,
  ],
})
export class ContainerCardComponent {
  readonly content = input.required<ContainerCardContent>();

  readonly headline = computed(() => this.content().headline);
  readonly subheading = computed(() => this.content().subheading);
  readonly presentation = computed(() => this.content().presentation);
  readonly theme = computed(() => this.content().theme ?? ContainerCardContentTheme.TRANSPARENT);
  readonly mobileLayout = computed(() => this.content().mobileLayout);
  readonly cards = computed(() => this.content().cards.filter((item) => item) ?? []);
  readonly cta = computed(() => this.content().cta);
  readonly pageSectionBackground = computed(() => this.content().backgroundColorRGB ?? '');

  readonly ContainerCardPresentation = ContainerCardPresentation;

  readonly #urlCtaService: UrlCtaService = inject(UrlCtaService);

  isPresentationType = () => this.presentation() === ContainerCardPresentation.LIST;

  navigateTo(): void {
    this.#urlCtaService.navigate(this.cta());
  }
}
